"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
import { useCompactMode } from "@/contexts/CompactModeContext";
import { ApiDropType } from "@/generated/models/ApiDropType";
import { getFileInfoFromUrl } from "@/helpers/file.helpers";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import { useContext } from "react";
import WaveDropActionsAddReaction from "./WaveDropActionsAddReaction";
import WaveDropActionsCopyLink from "./WaveDropActionsCopyLink";
import WaveDropActionsDownload from "./WaveDropActionsDownload";
import WaveDropActionsEdit from "./WaveDropActionsEdit";
import WaveDropActionsMarkUnread from "./WaveDropActionsMarkUnread";
import WaveDropActionsOpen from "./WaveDropActionsOpen";
import WaveDropActionsOptions from "./WaveDropActionsOptions";
import WaveDropActionsQuote from "./WaveDropActionsQuote";
import WaveDropActionsRate from "./WaveDropActionsRate";
import WaveDropActionsReply from "./WaveDropActionsReply";
import WaveDropFollowAuthor from "./WaveDropFollowAuthor";
interface WaveDropActionsProps {
  readonly drop: ExtendedDrop;
  readonly activePartIndex: number;
  readonly showVoting?: boolean;
  readonly onReply: () => void;
  readonly onQuote: () => void;
  readonly onEdit?: () => void;
}
export default function WaveDropActions(t0) {
  const $ = _c(58);
  const {
    drop,
    activePartIndex,
    showVoting: t1,
    onReply,
    onQuote,
    onEdit
  } = t0;
  const showVoting = t1 === undefined ? true : t1;
  const {
    connectedProfile
  } = useContext(AuthContext);
  const {
    canDelete
  } = useDropInteractionRules(drop);
  const {
    isMemesWave
  } = useSeizeSettings();
  const compact = useCompactMode();
  let t2;
  if ($[0] !== drop.drop_type || $[1] !== drop.wave?.id || $[2] !== isMemesWave || $[3] !== showVoting) {
    t2 = showVoting && !(drop.drop_type === ApiDropType.Participatory && isMemesWave(drop.wave?.id));
    $[0] = drop.drop_type;
    $[1] = drop.wave?.id;
    $[2] = isMemesWave;
    $[3] = showVoting;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const shouldShowVoting = t2;
  const t3 = `tw-absolute tw-z-20 tw-right-2 ${compact ? "-tw-top-4" : "tw-top-0"} group-hover:tw-opacity-100 tw-opacity-0 tw-transition-opacity tw-duration-200 tw-ease-in-out`;
  let t4;
  if ($[5] !== activePartIndex || $[6] !== connectedProfile?.handle || $[7] !== drop) {
    t4 = connectedProfile?.handle !== drop.author.handle && !activePartIndex && <WaveDropFollowAuthor drop={drop} />;
    $[5] = activePartIndex;
    $[6] = connectedProfile?.handle;
    $[7] = drop;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== drop) {
    t5 = <WaveDropActionsMarkUnread drop={drop} />;
    $[9] = drop;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== activePartIndex || $[12] !== drop || $[13] !== onReply) {
    t6 = <WaveDropActionsReply onReply={onReply} drop={drop} activePartIndex={activePartIndex} />;
    $[11] = activePartIndex;
    $[12] = drop;
    $[13] = onReply;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== activePartIndex || $[16] !== drop || $[17] !== onQuote) {
    t7 = <WaveDropActionsQuote onQuote={onQuote} drop={drop} activePartIndex={activePartIndex} />;
    $[15] = activePartIndex;
    $[16] = drop;
    $[17] = onQuote;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  let t9;
  if ($[19] !== drop) {
    t8 = <WaveDropActionsCopyLink drop={drop} />;
    t9 = <WaveDropActionsOpen drop={drop} />;
    $[19] = drop;
    $[20] = t8;
    $[21] = t9;
  } else {
    t8 = $[20];
    t9 = $[21];
  }
  let t10;
  if ($[22] !== drop.id || $[23] !== drop.parts) {
    bb0: {
      const media = drop.parts?.at(0)?.media?.at(0);
      const url = media?.url;
      if (!url) {
        t10 = null;
        break bb0;
      }
      const info = getFileInfoFromUrl(url);
      if (!info) {
        t10 = null;
        break bb0;
      }
      const t11 = `download-media-${drop.id}`;
      let t12;
      if ($[25] !== info.extension || $[26] !== info.name || $[27] !== t11 || $[28] !== url) {
        t12 = <WaveDropActionsDownload href={url} name={info.name} extension={info.extension} tooltipId={t11} />;
        $[25] = info.extension;
        $[26] = info.name;
        $[27] = t11;
        $[28] = url;
        $[29] = t12;
      } else {
        t12 = $[29];
      }
      t10 = t12;
    }
    $[22] = drop.id;
    $[23] = drop.parts;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[30] !== drop || $[31] !== onEdit) {
    t11 = onEdit && drop.drop_type !== ApiDropType.Participatory && <WaveDropActionsEdit drop={drop} onEdit={onEdit} />;
    $[30] = drop;
    $[31] = onEdit;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== canDelete || $[34] !== drop) {
    t12 = canDelete && <WaveDropActionsOptions drop={drop} />;
    $[33] = canDelete;
    $[34] = drop;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== drop) {
    t13 = <WaveDropActionsAddReaction drop={drop} />;
    $[36] = drop;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== t10 || $[39] !== t11 || $[40] !== t12 || $[41] !== t13 || $[42] !== t4 || $[43] !== t5 || $[44] !== t6 || $[45] !== t7 || $[46] !== t8 || $[47] !== t9) {
    t14 = <div className="tw-h-8 tw-flex tw-items-center tw-shadow tw-bg-iron-950 tw-ring-1 tw-ring-iron-800 tw-ring-inset tw-rounded-lg">{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}</div>;
    $[38] = t10;
    $[39] = t11;
    $[40] = t12;
    $[41] = t13;
    $[42] = t4;
    $[43] = t5;
    $[44] = t6;
    $[45] = t7;
    $[46] = t8;
    $[47] = t9;
    $[48] = t14;
  } else {
    t14 = $[48];
  }
  let t15;
  if ($[49] !== drop || $[50] !== shouldShowVoting) {
    t15 = shouldShowVoting && <WaveDropActionsRate drop={drop} />;
    $[49] = drop;
    $[50] = shouldShowVoting;
    $[51] = t15;
  } else {
    t15 = $[51];
  }
  let t16;
  if ($[52] !== t14 || $[53] !== t15) {
    t16 = <div className="tw-flex tw-items-center tw-gap-x-2">{t14}{t15}</div>;
    $[52] = t14;
    $[53] = t15;
    $[54] = t16;
  } else {
    t16 = $[54];
  }
  let t17;
  if ($[55] !== t16 || $[56] !== t3) {
    t17 = <div className={t3}>{t16}</div>;
    $[55] = t16;
    $[56] = t3;
    $[57] = t17;
  } else {
    t17 = $[57];
  }
  return t17;
}